import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v4';

const activateSearchSchema = z
  .object({
    token: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/activate')({
  component: lazyRouteComponent(() => import('&/features/activation/pages/activation-page')),
  validateSearch: (search) => activateSearchSchema.parse(search),
});
